exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".curriculumListComponent---1AaWM{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;font-family:Poppins,sans-serif;background-color:#cfd2d4;-webkit-box-direction:normal;-webkit-box-orient:vertical;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.curriculumFilterComponent---1-96z{display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;font-family:Poppins,sans-serif;background-color:#cfd2d4;padding:0 25px;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;min-height:80px}.curriculumFilterComponent---1-96z>div{margin-right:20px}", ""]);

// exports
exports.locals = {
	"curriculumListComponent": "curriculumListComponent---1AaWM",
	"curriculumFilterComponent": "curriculumFilterComponent---1-96z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/curriculum-list/index.scss
// module id = 754
// module chunks = 3